import { createDefaultTyrann } from '@apis/common';
import { inquiryDetailCargos, tradeCondtion } from '@models/BookingInquiry';
import { country } from '@models/Country';
import { routePlan, routePlanSimulator } from '@models/RoutePlan';
import { useTradingAgency } from '@models/TradingAgency';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const routePlanSimulatorType = t.union([
  t.literal('BOOKING_CREATE'),
  t.literal('PRICE_SIMULATOR'),
]);

export type RoutePlanSimulatorType = t.TypeOf<typeof routePlanSimulatorType>;

export const postRoutePlanSimulator = t.type({
  pickup_date: h.omittableString(),
  move_in_date: h.omittableString(),
  zipcode: t.string,
  cargos: inquiryDetailCargos,
  trade_condition: tradeCondtion,
  trading_agency_payer: country,
  use_trading_agency: useTradingAgency,
  owner_id: t.number,
  city_cd: h.omittableString(),
  truck_type: h.omittableString(),
});

export type PostRoutePlanSimulator = t.TypeOf<typeof postRoutePlanSimulator>;

export const routePlanSimulatorStatus = t.type({
  count: t.number,
  last_used: t.string,
});

export type RoutePlanSimulatorStatus = t.TypeOf<typeof routePlanSimulatorStatus>;

export const routePlanApis = createDefaultTyrann({
  '/route-plan-simulator/': {
    post: {
      query: t.type({ type: routePlanSimulatorType }),
      body: postRoutePlanSimulator,
      response: {
        200: t.array(routePlanSimulator),
        404: t.type({
          message: h.omittableString(),
        }),
      },
    },
    get: {
      response: {
        200: routePlanSimulatorStatus,
      },
    },
  },
  '/route-plan/{id}/': {
    get: {
      path: t.type({ id: t.number }),
      response: {
        200: routePlan,
      },
    },
  },
});
